import _ from 'lodash';
import { fork, put, select, take, takeLatest } from 'redux-saga/effects';

import { THREATMETRIX_ORG_ID } from './ThreatMetrix';

function* activateThreatMetrix() {
    yield takeLatest('page/ACTIVATE_THREATMETRIX', function* () {
        yield put({ type: 'api/POST_THREATMETRIX' });
        yield take('api/POST_THREATMETRIX [success]');

        const { sessionID } = yield select(({ lendingAPI }) => ({
            sessionID: _.get(lendingAPI, 'threatmetrix.data.tm_session_id')
        }));

        if (window.threatmetrix) {
            window.threatmetrix.profile(
                'h.online-metrix.net',
                THREATMETRIX_ORG_ID,
                sessionID
            );
            yield put({ type: 'api/PUT_THREATMETRIX', sessionID });
        }
    });
}

export default [fork(activateThreatMetrix)];
